import { Building2, Building } from 'lucide-react';

import { FacilitiesRootLayout } from './_components/_layouts/FacilitiesRootLayout';
import { FacilitiesListView } from './_components/management/_FacilitiesListView';
import { FacilityGroupListView } from './_components/management/_FacilityGroupListView';

import { createAppModule } from '~/shared/routing/createAppModule';
import { createModuleNav } from '~/shared/routing/createModuleNav';
import { createModuleRoutes } from '~/shared/routing/createModuleRoutes';

const basePath = '/facilities';

export const facilitiesRoutes = createModuleRoutes({
  root: {
    path: basePath,
    label: (t) => t.menu.facilities.root,
    icon: Building2,
  },
  facilityManagement: {
    path: `${basePath}/management`,
    label: (t) => t.menu.facilities.management.root,
    icon: Building,
  },
  managementGroups: {
    path: `${basePath}/management/groups`,
    label: (t) => t.menu.facilities.management.groups,
    component: FacilityGroupListView,
    requiredPermission: 'facilityGroupRead',
  },
  managementFacilities: {
    path: `${basePath}/management/facilities`,
    label: (t) => t.menu.facilities.management.facilities,
    component: FacilitiesListView,
    requiredPermission: 'facilityRead',
  },
});

const facilitiesNav = createModuleNav(($) =>
  $(facilitiesRoutes.root, [
    $(facilitiesRoutes.facilityManagement, [
      $(facilitiesRoutes.managementGroups),
      $(facilitiesRoutes.managementFacilities),
    ]),
  ]),
);

export const facilitiesModule = createAppModule({
  routes: facilitiesRoutes,
  nav: facilitiesNav,
  layout: FacilitiesRootLayout,
});
